import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export function useCollection<T>(table: string, orderKey = "sort_order") {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data, error: err } = await supabase
        .from(table)
        .select("*")
        .order(orderKey, { ascending: true });
      if (err) throw err;
      setItems((data ?? []) as T[]);
    } catch {
      setError("Impossible de charger les données.");
    } finally {
      setLoading(false);
    }
  }, [table, orderKey]);

  useEffect(() => {
    load();
  }, [load]);

  return { items, loading, error, reload: load };
}